// extracted by mini-css-extract-plugin
export default {"publish-main-content":"PublishDocumentWindow_publish-main-content__DCkfl","title":"PublishDocumentWindow_title__bX0Pw"};